<template>
    <v-container :fluid="fluid">
        <slot v-if="showError && $slots.errorMessage" name="errorMessage"></slot>
        <v-alert v-else :value="showError" type="error">
            {{ 'Something went wrong. Please reload the page and try again.' | translation }}
        </v-alert>

        <v-alert :value="showSizeLimitError" type="error">
            {{'Attached file\'s size is too big. Maximum size limit is ' + sizeLimit + 'Mb.' | translation}}
        </v-alert>

        <v-form ref="form" @submit.prevent="submit">
            <slot v-if="!sent" name="headlineBeforeSending"></slot>
            <slot v-else name="headlineAfterSending"></slot>

            <slot v-if="!sent" name="descriptionBeforeSending"></slot>
            <slot v-else name="descriptionAfterSending"></slot>

            <slot v-if="!sent"></slot>

            <slot v-if="!sent" name="submit" :loading="loading"></slot>
        </v-form>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import formSerialize from 'form-serialize';

    const moduleName = 'ContactForm';

    export default {
        name: moduleName,
        props: {
            actionParams: String,
            fluid: Boolean,
        },
        data() {
            return {
                sent: false,
                showError: false,
                loading: false,
                sizeLimit: 30, //Mb
                showSizeLimitError: false,
            };
        },
        methods: {
            ...mapActions(moduleName, [
                'sendFormData',
            ]),
            async submit() {
                this.loading = true;
                this.showError = false;
                this.showSizeLimitError = false;

                if (this.$refs.form.validate()) {
                    const data = formSerialize(this.$refs.form.$el, {hash: true});
                    data.files = {};

                    let sizeTotal = 0;
                    if (this.$refs.form.$el.querySelectorAll('input[type=file]').length) {
                        for (let fileEl of this.$refs.form.$el.querySelectorAll('input[type=file]')) {
                            for (let file of fileEl.files) {
                                let content = await this.getFileBase64(file);
                                sizeTotal += file.size / (1000 * 1000);
                                data.files[file.name] = content;
                            }
                        }
                    }

                    if (sizeTotal > this.sizeLimit - 1) {
                        this.showSizeLimitError = true;
                        this.loading = false;
                        return;
                    }

                    this.sendFormData({
                        params: this.actionParams,
                        data,
                    }).then(result => {
                        if (result && result.success) {
                            this.sent = true;
                        } else {
                            this.showError = true;
                        }
                        this.loading = false;
                    }).catch(e => {
                        this.showError = true;
                        this.loading = false;
                    });
                }
            },
            getFileBase64(file) {
                return new Promise((resolve, reject) => {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = (error) => {
                        reject(error);
                    };
                });
            },
        },
    };
</script>